import { c as _c } from "react/compiler-runtime";
import { Lightning01Icon } from '@systemeio/icons';
import { PillRadioGroup } from 'shared/components/pill-radio-group';
import { DigitalResourcesTypeEnum } from 'modules/digital-product/enums/digital-resources-type-enum';
import { DefinedDigitalResource, ResourceFields } from 'modules/digital-product/resources/components/resource-fields';
import { useDigitalResourceTypes } from 'modules/digital-product/resources/hooks/use-digital-resource-types';
import { DigitalResourceEditType } from 'modules/digital-product/resources/types/digital-resource-edit-interface';
import { getDefaultResourceValue } from 'modules/digital-product/resources/utils/get-default-resource-value';
import { isResourceReady } from 'modules/digital-product/resources/utils/is-resource-ready';
import { IconTile } from 'shared/components/icon-tile';
import React, { useEffect, useState } from 'react';
import { Button, Modal } from 'shared/components';
import { useLocoTranslation } from 'shared/hooks/use-loco-translation';
interface ResourceModalProps {
  onClose: () => void;
  onSubmit: (resource: DigitalResourceEditType) => void;
  opened: boolean;
  /** Resource being edited; `undefined` turns the modal into the add flow. */
  resource?: DigitalResourceEditType;
}
export function ResourceModal(t0) {
  const $ = _c(64);
  const {
    onClose,
    onSubmit,
    opened,
    resource
  } = t0;
  const {
    t
  } = useLocoTranslation();
  const resourceTypes = useDigitalResourceTypes();
  let t1;
  if ($[0] !== resource) {
    t1 = resource ?? {
      type: undefined
    };
    $[0] = resource;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const [localResource, setLocalResource] = useState(t1);
  const isEdit = resource !== undefined;
  let t2;
  let t3;
  if ($[2] !== opened || $[3] !== resource) {
    t2 = () => {
      if (opened) {
        setLocalResource(resource ?? {
          type: undefined
        });
      }
    };
    t3 = [opened, resource];
    $[2] = opened;
    $[3] = resource;
    $[4] = t2;
    $[5] = t3;
  } else {
    t2 = $[4];
    t3 = $[5];
  }
  useEffect(t2, t3);
  let t4;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = type => setLocalResource(prev => ({
      ...getDefaultResourceValue(type),
      id: prev.id
    }));
    $[6] = t4;
  } else {
    t4 = $[6];
  }
  const handleChangeType = t4;
  let t5;
  if ($[7] !== localResource || $[8] !== onClose || $[9] !== onSubmit) {
    t5 = event => {
      event.preventDefault();
      if (!isResourceReady(localResource)) {
        return;
      }
      onSubmit(localResource);
      onClose();
    };
    $[7] = localResource;
    $[8] = onClose;
    $[9] = onSubmit;
    $[10] = t5;
  } else {
    t5 = $[10];
  }
  const handleSubmit = t5;
  let t6;
  if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <IconTile size="m" tone="gray"><Lightning01Icon /></IconTile>;
    $[11] = t6;
  } else {
    t6 = $[11];
  }
  const t7 = isEdit ? "dashboard.digital_product.resources.header.edit-title" : "dashboard.digital_product.resources.header.add-title";
  let t8;
  if ($[12] !== t || $[13] !== t7) {
    t8 = t(t7);
    $[12] = t;
    $[13] = t7;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== t8) {
    t9 = <span>{t8}</span>;
    $[15] = t8;
    $[16] = t9;
  } else {
    t9 = $[16];
  }
  let t10;
  if ($[17] !== t) {
    t10 = t("dashboard.digital_product.resources.description");
    $[17] = t;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  let t11;
  if ($[19] !== t10) {
    t11 = <span className="text-text-tertiary text-sm font-normal">{t10}</span>;
    $[19] = t10;
    $[20] = t11;
  } else {
    t11 = $[20];
  }
  let t12;
  if ($[21] !== t11 || $[22] !== t9) {
    t12 = <div className="flex items-center gap-4">{t6}<div className="flex flex-col">{t9}{t11}</div></div>;
    $[21] = t11;
    $[22] = t9;
    $[23] = t12;
  } else {
    t12 = $[23];
  }
  let t13;
  if ($[24] !== handleSubmit) {
    t13 = <form onSubmit={handleSubmit} />;
    $[24] = handleSubmit;
    $[25] = t13;
  } else {
    t13 = $[25];
  }
  let t14;
  if ($[26] !== t) {
    t14 = t("global.cancel");
    $[26] = t;
    $[27] = t14;
  } else {
    t14 = $[27];
  }
  let t15;
  if ($[28] !== onClose || $[29] !== t14) {
    t15 = <Button type="button" className="tablet:flex-none flex-1" onClick={onClose} variant="secondary" size="md">{t14}</Button>;
    $[28] = onClose;
    $[29] = t14;
    $[30] = t15;
  } else {
    t15 = $[30];
  }
  let t16;
  if ($[31] !== localResource) {
    t16 = isResourceReady(localResource);
    $[31] = localResource;
    $[32] = t16;
  } else {
    t16 = $[32];
  }
  const t17 = !t16;
  const t18 = isEdit ? "global.save" : "dashboard.funnel.configuration.offer.add_digital_resource";
  let t19;
  if ($[33] !== t || $[34] !== t18) {
    t19 = t(t18);
    $[33] = t;
    $[34] = t18;
    $[35] = t19;
  } else {
    t19 = $[35];
  }
  let t20;
  if ($[36] !== t17 || $[37] !== t19) {
    t20 = <Button disabled={t17} className="tablet:flex-none flex-1" type="submit" variant="primary" size="md">{t19}</Button>;
    $[36] = t17;
    $[37] = t19;
    $[38] = t20;
  } else {
    t20 = $[38];
  }
  let t21;
  if ($[39] !== t15 || $[40] !== t20) {
    t21 = <>{t15}{t20}</>;
    $[39] = t15;
    $[40] = t20;
    $[41] = t21;
  } else {
    t21 = $[41];
  }
  let t22;
  if ($[42] !== t) {
    t22 = t("dashboard.digital_product.resources.type");
    $[42] = t;
    $[43] = t22;
  } else {
    t22 = $[43];
  }
  let t23;
  if ($[44] !== t22) {
    t23 = <span className="text-sm font-medium">{t22}</span>;
    $[44] = t22;
    $[45] = t23;
  } else {
    t23 = $[45];
  }
  let t24;
  if ($[46] !== localResource.type || $[47] !== resourceTypes) {
    t24 = <PillRadioGroup options={resourceTypes} value={localResource.type} onChange={handleChangeType} />;
    $[46] = localResource.type;
    $[47] = resourceTypes;
    $[48] = t24;
  } else {
    t24 = $[48];
  }
  let t25;
  if ($[49] !== t23 || $[50] !== t24) {
    t25 = <div className="flex flex-col gap-2">{t23}{t24}</div>;
    $[49] = t23;
    $[50] = t24;
    $[51] = t25;
  } else {
    t25 = $[51];
  }
  let t26;
  if ($[52] !== localResource) {
    t26 = localResource.type && <ResourceFields withLabels={true} resource={localResource as DefinedDigitalResource} onChange={data => setLocalResource(prev_0 => prev_0.type === data.type ? {
      ...prev_0,
      ...data
    } as DigitalResourceEditType : prev_0)} />;
    $[52] = localResource;
    $[53] = t26;
  } else {
    t26 = $[53];
  }
  let t27;
  if ($[54] !== t25 || $[55] !== t26) {
    t27 = <div className="flex flex-col gap-4">{t25}{t26}</div>;
    $[54] = t25;
    $[55] = t26;
    $[56] = t27;
  } else {
    t27 = $[56];
  }
  let t28;
  if ($[57] !== onClose || $[58] !== opened || $[59] !== t12 || $[60] !== t13 || $[61] !== t21 || $[62] !== t27) {
    t28 = <Modal opened={opened} onClose={onClose} title={t12} render={t13} footer={t21}>{t27}</Modal>;
    $[57] = onClose;
    $[58] = opened;
    $[59] = t12;
    $[60] = t13;
    $[61] = t21;
    $[62] = t27;
    $[63] = t28;
  } else {
    t28 = $[63];
  }
  return t28;
}